import { setGetCampaignAction } from '../action';
import { getCampaign } from '../api/getCampaign';

export const setGetCampaign = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getCampaign(params);
            dispatch(setGetCampaignAction({
                data: data.data,
                current: 0,
                total: 0
            }))

            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}